import { BuildingBlockPostType, RoundtripPostType } from '@typings'

export const buildingBlockOrRoundtrip = (
  block: BuildingBlockPostType | RoundtripPostType
) => {
  if (block.type === 'reise-baustein') return 'bb'
  if (block.type === 'rundreise') return 'rt'
}
